var ArchieTokenExpiredException, BaseException, NoActiveSubscriptionException, ServerException, ValidationException, exception,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

BaseException = require('base/lib/exception');

exception = function(name, params) {
  var Exception;
  if (params == null) {
    params = {};
  }
  return Exception = (function(_super) {
    __extends(Exception, _super);

    function Exception() {
      Exception.__super__.constructor.call(this, name, $.t("errors:" + name, params));
    }

    return Exception;

  })(BaseException);
};

ValidationException = (function(_super) {
  __extends(ValidationException, _super);

  function ValidationException(msg) {
    ValidationException.__super__.constructor.call(this, 'validation', $.t('errors:general.data_validation', {
      msg: msg
    }));
  }

  return ValidationException;

})(BaseException);

ServerException = (function(_super) {
  __extends(ServerException, _super);

  function ServerException(msg) {
    ServerException.__super__.constructor.call(this, 'server', $.t('errors:general.server_reported_error', {
      msg: msg
    }));
  }

  return ServerException;

})(BaseException);

NoActiveSubscriptionException = (function(_super) {
  __extends(NoActiveSubscriptionException, _super);

  function NoActiveSubscriptionException(previousSubscription) {
    this.previousSubscription = previousSubscription;
    NoActiveSubscriptionException.__super__.constructor.call(this, 'authentication.no_active_subscription', $.t('errors:authentication.no_active_subscription'));
  }

  return NoActiveSubscriptionException;

})(BaseException);

ArchieTokenExpiredException = (function(_super) {
  __extends(ArchieTokenExpiredException, _super);

  function ArchieTokenExpiredException() {
    ArchieTokenExpiredException.__super__.constructor.call(this, 'archie_token_expired', 'token_expired');
  }

  return ArchieTokenExpiredException;

})(BaseException);

module.exports = {
  localized: function(name) {
    return new (exception(name));
  },
  authentication: {
    server: exception('authentication.server'),
    local_login: exception('authentication.local_login'),
    empty_email: exception('authentication.empty_email'),
    empty_password: exception('authentication.empty_password'),
    local_no_udb: exception('authentication.local_no_udb'),
    invalid_email: exception('authentication.invalid_email'),
    email_in_use: exception('authentication.email_in_use'),
    invalid_password: exception('authentication.invalid_password'),
    tos_not_accepted: exception('authentication.tos_not_accepted'),
    cannot_load_local_data: exception('authentication.cannot_load_local_data'),
    user_not_found: exception('authentication.user_not_found'),
    user_inactive: exception('authentication.user_inactive'),
    no_login_for_email: exception('authentication.no_login_for_email'),
    no_login_for_email_local: exception('authentication.no_login_for_email_local'),
    unable_to_get_login_for_email: exception('authentication.unable_to_get_login_for_email'),
    oauth_flow_failed: exception('authentication.oauth_flow_failed'),
    forbidden: exception('authentication.forbidden'),
    registration_disabled: exception('authentication.registration_disabled'),
    no_active_subscription: NoActiveSubscriptionException
  },
  no_connection: exception('general.no_connection'),
  server_error: exception('general.server_error'),
  request_not_found: exception('general.request_not_found'),
  migration_failed: function(name) {
    return new (exception("migration." + (_.str.underscored(name))));
  },
  validation: ValidationException,
  server_reported: ServerException,
  project_document_not_valid: exception('general.project_document_not_valid'),
  data_changed: exception('general.data_changed'),
  document_missing: exception('general.document_missing'),
  project_missing_on_server: exception('general.project_missing_on_server'),
  project_cannot_be_fetched: exception('general.project_cannot_be_fetched'),
  "import": {
    unrecognized_grd: exception('import.unrecognized_grd'),
    no_projects_in_file: exception('import.no_projects_in_file'),
    malformed_grd_file: exception('import.malformed_grd_file'),
    unsupported_review_type: function(reviewType) {
      return new (exception('import.unsupported_review_type', {
        reviewType: reviewType
      }));
    }
  },
  dbep: {
    no_connection: exception('dbep.no_connection'),
    feature_disabled: exception('dbep.feature_disabled'),
    upload_fail: exception('dbep.upload_fail'),
    cancel_fail: exception('dbep.cancel_fail'),
    server_error: exception('dbep.server_error')
  },
  archie: {
    token_expired: ArchieTokenExpiredException
  },
  references: {
    attachments: {
      upload_fail: exception('references.attachments.upload_fail'),
      too_large: exception('references.attachments.too_large'),
      unauthorized: exception('references.attachments.unauthorized'),
      forbidden: exception('references.attachments.forbidden'),
      not_found: exception('references.attachments.not_found'),
      no_connection: exception('references.attachments.no_connection')
    }
  },
  quality_indicators: {
    etd_document_missing: exception('quality_indicators.etd_document_missing'),
    document_missing: exception('quality_indicators.document_missing')
  }
};
